import styled, { css } from 'styled-components';

export const DatePickerContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !['widthInput', 'readonly', 'valid'].includes(prop),
})`
  position: relative;
  width: ${(props) => props.widthInput};
  height: 40px;
  border-radius: 4px;
  border: solid 1px ${(props) => props.theme.colors.link};
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textPrimary};
  padding: 10px 5px 10px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ disabled, readonly }) =>
    disabled &&
    !readonly &&
    css`
      cursor: not-allowed;
      background-color: rgba(63, 63, 63, 0.7);
      color: ${(props) => props.theme.colors.greyMedium};
      border: solid 1px ${(props) => props.theme.colors.greyMedium};
    `};

  ${({ readonly }) =>
    readonly &&
    css`
      pointer-events: none;
      border: none;
      background-color: 'transparent';
      padding: 10px 0;
    `};

  input {
    cursor: pointer;
    background-color: transparent;
    border: none;
    border-radius: 4px;
    color: inherit;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.textPrimary};
    width: inherit;
    //to fix focus ring width/positioning
    margin-inline: -11px;
    padding-inline: 10px;

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.focusRing};
      outline-offset: -2px;
    }

    ${({ disabled, readonly, theme }) =>
      disabled &&
      !readonly &&
      css`
        cursor: not-allowed;
        color: ${(props) => props.theme.colors.greyMedium};
      `};

    &::placeholder {
      font-weight: normal;
      font-style: italic;
      color: gray;
    }

    &::-webkit-input-placeholder {
      /* Edge */
      font-weight: normal;
      font-style: italic;
      color: gray;
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      font-weight: normal;
      font-style: italic;
      color: gray;
    }
  }

  .react-datepicker-wrapper {
    width: 100%;

    .react-datepicker__input-container {
      z-index: 2;

      input,
      input::placeholder {
        font-family: ${({ theme }) => theme.fontset.titillium};
        font-style: normal;
        color: ${(props) => props.theme.colors.link};
        font-size: 18px;
        font-weight: 600;
        line-height: 38px;
      }
    }
  }

  .react-datepicker {
    font-family: ${({ theme }) => theme.fontset.titillium};
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--selected {
    background-color: unset;
    border-radius: 8px;
    transition: all 250ms ease-in-out;
  }
  .react-datepicker__day--selected[aria-selected] {
    background-color: ${(props) => props.theme.colors.link};
  }
  .react-datepicker__day {
    border-radius: 8px;
    transition: all 250ms ease-in-out;
    &:hover {
      border-radius: 0;
    }
  }

  div.react-datepicker-popper {
    transform: translate3d(0, 32px, 0);
    z-index: 3;
  }

  .react-datepicker__close-icon {
    right: 8px;
    top: -2px;

    &::after {
      background-color: transparent;
      color: ${(props) => props.theme.colors.textSecondary};
      padding: 0;
      font-size: 24px;
    }
  }
`;
